'use client';
import React, { useState } from 'react';
import FeedFilters from './FeedFilters';
import FeedList from './FeedList';
import FeedSidebar from './FeedSidebar';
import UserSearch from './UserSearch';
import Link from 'next/link';
import { useAuth } from '@/contexts/AuthContext';
import { PenLine } from 'lucide-react';

export default function RunwayFeedContent() {
  const { user, profile } = useAuth();
  const [filter, setFilter] = useState<'all' | 'editorial' | 'lookbook'>('all');

  return (
    <div className="flex gap-8 xl:gap-12">
      {/* Main Feed */}
      <div className="flex-1 min-w-0">
        <div className="mb-6 flex items-start justify-between gap-4">
          <div>
            <h1 className="font-editorial text-3xl font-semibold text-charcoal-900" style={{ fontFamily: "'Cinzel', serif" }}>The Runway</h1>
            <p className="text-sm text-charcoal-500 mt-1">
              Opinion pieces and lookbooks from the community
            </p>
          </div>
          <div className="flex items-center gap-3 shrink-0">
            <UserSearch />
            {user && (profile?.role === 'icon' || profile?.role === 'admin' || profile?.role === 'enthusiast') && (
              <Link href="/create-post"
                className="flex items-center gap-2 px-4 py-2.5 bg-charcoal-900 text-white rounded-xl text-sm font-semibold hover:bg-charcoal-800 active:scale-[0.98] transition-all duration-150 shrink-0"
                style={{ fontFamily: "'Cinzel', serif" }}>
                <PenLine size={15} />
                New Post
              </Link>
            )}
          </div>
        </div>
        <FeedFilters activeFilter={filter} onFilterChange={setFilter} />
        <FeedList filter={filter} />
      </div>
      {/* Sidebar */}
      <div className="hidden xl:block w-72 2xl:w-80 shrink-0">
        <FeedSidebar />
      </div>
    </div>
  );
}